import { toast } from "sonner";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { useRestoreLead } from "@/hooks/useLeads";

type Props = {
  leadId: string;
  leadName: string | null;
  open: boolean;
  onClose: () => void;
};

export function RestoreLeadDialog({
  leadId,
  leadName,
  open,
  onClose,
}: Props): React.JSX.Element {
  const restoreLead = useRestoreLead();
  const displayName = leadName ?? "este lead";

  function handleConfirm(): void {
    restoreLead.mutate(leadId, {
      onSuccess: () => {
        toast.success("Lead restaurado");
        onClose();
      },
      onError: (err) => {
        toast.error(err.message ?? "Error al restaurar el lead");
      },
    });
  }

  return (
    <AlertDialog open={open} onOpenChange={(v: boolean) => !v && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Restaurar a {displayName}?</AlertDialogTitle>
          <AlertDialogDescription>
            Volverá a aparecer en el tablero en su etapa anterior.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={restoreLead.isPending}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={restoreLead.isPending}
          >
            {restoreLead.isPending ? "Restaurando…" : "Restaurar"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
